module.exports = __webpack_public_path__ + "static/img/Architecture_报账_image@2x.9309dca9.png";